// extracted by mini-css-extract-plugin
export default {"underlined_button":"uv"};
    if(module.hot) {
      // 1738836192894
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  